import {
    observable,
    action,
    computed,
    //runInAction
} from 'mobx'
import {appStoreCloudApis} from 'Api/index'
import { windowActionFn, getQueryVariable, isMore20201231, isPdfOnlineDomain, isCommonFeatureDomain, isDemo4Domain, updateProp, getFoxitStoreDomain } from '../utils/utils';
import {accountService, userService} from './services/index'
import {
    USER_SIGN_IN_SUCCESS,
    USER_UPDATE_SUBSCRIPTION,
    USER_TEMP_TRIAL,
    GOT_USER_SUBSCRIPTION,
} from './constants';
import {APP_CODES} from 'constants/index'
import {store} from 'Store/store.index';
import {
    SUBSCRIBED_NO_PLAN,
    SUBSCRIBED_PLAN
} from 'Components/viewer/ui/constants/user.more.constants';
import { permissionManager } from "Components/viewer/ui/PermissionManager/PermissionManager";
// import { otelApi } from 'Api/index'
import { msForTeamsAppApi } from '../api/index';
import { USER_AB_ROLE } from 'Api/constants';

/**
 * @typedef Plan
 * @property {String} stripe_plan_id
 * @property {String} plan_name
 * @property {String} app_code
 * @property {String} type
 * @property {String} value {value = plan.app_code +"-" +plan.type;}
 * @property {String} price
 * @property {String} currency
 * @property {String} original_price
 * @property {String} original_price_mac
 * @property {String} can_change
 * @property {String} effective_date
 * @property {String} expiration_date
 */

 /**
 * @typedef AppPlan
 * @property {String} app_code "phantom_ga_business"
 * @property {String} plan_type "monthly"
 * @property {String} plan_id "phantom_ga_business_monthly_1_14_1469694988"
 * @property {String} status "active"
 * @property {String} next_plan
 * @property {String} next_plan_time
 * @property {String} updated
 * @property {Object} expiredDate
 * @property {String} stripe_subscription_id
 */
 /**
  * @typedef SubscribedApps
  * @property {String} app_name
  * @property {AppPlan[]} subscriptions
  */

 /**
  * @typedef SubscribeInfo
  * @property {Boolean} isSubscribed
  * @property {Boolean} redeem_subscription
  * @property {SubscribedApps[]} subscribedApps
  * @property {AppPlan[]} expiredSubscriptions
  * @property {String} phantom_online_trial_start
  * @property {Number} phantom_online_trial_start_timestamp
  * @property {Number} current_timestamp
  * @property {Number} remain_days
  * @property {Boolean} can_use_paid_service
  */
/**
 * 1. to get subscribeInfo
 */

let subscribeInfoIntervalFlag

class AccountStore {
    /**@type {Promise<Object>} request subscribe */
    @observable.ref initializeTask = null;
    @observable.ref subscribeInfoCache = null;
    /**@type {Promise<Object>} request subscribe */
    @observable.ref requestTask = null;
    /**@type {Promise<Object>} */
    @observable.ref requestEduTask = null;

    @observable distributorID = null;
    @observable isMock = false;

    /** @type {SubscribeInfo} */
    @observable.ref subscribeInfo = null;
    /**
     *
     * {{status}}   {
     *   status: active, expired, trailExpired, trail
     * }
    */
    @observable subscriptionState = null;
    /**
     * @type {null|Object[]}
     * data format:
        [{
            "duration": "10000", //(unit: second)
            "times": "10",
            "name": "PDF2Office"
        },...]
     */
    @observable dashboardPermission = null;// [{"duration": "10000", "times": 1, "name": "PDF2Office"}]; // debug
    @observable dashboardTrial = false; // debug
    /**
        {'groupName': {timestamp, usedTimes, list, ...}}
    */
    @observable dashboardTrialInfo = {};
    /**{ key1:Plan, key2:Plan, ...} */
    @observable.ref plans = null
    /**@type {null|Plan[]} */
    @observable.ref apps = []
    // ["phantom_ga_online","phantom_ga_business","phantom_ga_standard","phantom_ga_education"];
    @observable _app_codes = APP_CODES;
    //@observable _app_org_codes = ["phantom_ga_online_org","phantom_ga_business_org","phantom_ga_standard_org","phantom_ga_education_org"];
    @observable user_stripe_sub_num = '';
    // trail from : online / bundle
    @observable trial_from = '';

    // A/B test role
    @observable account_test_group = null;
    @observable hasGotUserABRole = `hk_`+Math.random();

    @computed get needABTest() {
        return this.account_test_group !== null;
    }
    @computed get testUserGroup() {
        return this.account_test_group;
    }
    // old ui
    @computed get isAUserGroup() {
        return this.account_test_group === USER_AB_ROLE.A;
    }
    // new ui (custom toolbar & language setting)
    @computed get isBUserGroup() {
        return this.account_test_group === USER_AB_ROLE.B;
    }
    @action setUserABRole(role = null) {
        this.account_test_group = role;
        this.setHasGotUserABRole();
    }
    @action setHasGotUserABRole() {
        this.hasGotUserABRole = `hk_`+Math.random();
    }


    @computed get isNewSubscribeStrategy() {
        const newSubscribeStrategyStartTime = '2023-05-21 00:00:00';
        const { isEnterpriseUser } = store.userStore

        if (!isEnterpriseUser) {
            let result = !this.apps.some(app => app.order_created < newSubscribeStrategyStartTime);

            return result;
        }

        return true;
    }
    @computed get isSubscribe() {
        //org_code === "covid2019"
        if(!this.apps || this.apps.length === 0){
            return false;
        }
        let isActive = false;
        isActive = this.apps.some((app)=>{
            return app.app_code && app.status === 'active' && app.org_code !== "covid2019";
        })
        return isActive;
        // if (this.apps && this.apps.length && this.apps[0].app_code && this.apps[0].status === 'active') {
        //     return true
        // } else {
        //     return false
        // }
    }
    @computed get isPhantomGAEducationOrg() {
        if (!this.apps || this.apps.length === 0) {
            return false;
        }
        return this.apps.some(app => app.app_code === 'phantom_ga_education_org');
    }
    @computed get isActive(){
        //status: active, expired, trailExpired, trail
        if(!this.subscriptionState) return false;
        if(this.subscriptionState.status !== 'active') return false;
        return true;
    }
    @computed get isExpired(){
        //status: active, expired, trailExpired, trail
        if(!this.subscriptionState) return false;
        if(this.subscriptionState.status !== 'expired') return false;
        return true;
    }
    @computed get isTrial(){//是否为试用状态
        //status: active, expired, trailExpired, trail
        if(!this.subscriptionState) return false;
        if(this.subscriptionState.status !== 'trail') return false;
        if(this.dashboardTrial) return false;
        return true;
    }
    @computed get isTrialExpired(){
        //status: active, expired, trailExpired, trail
        if(!this.subscriptionState) return false;
        if(this.subscriptionState.status !== 'trailExpired') return false;
        return true;
    }
    // 新注册用户，没有第一次试用过。
    // 以前是注册后就有5天试用，现在这个是新用户到现在从没有开通过online试用
    // 这个时候对应的remain days 不是具体数值，而是null
    @computed get isNoFirstTrail(){
        if(!this.subscriptionState) return false;
        if(this.subscriptionState.status !== 'noFirstTrailed') return false;
        return true;
    }
    // 是 bundle 相关的, 2023 新的订阅计划
    @computed get isBundle(){
        return this.trial_from === 'bundle_trial';
    }
    // 当前为试用状态，且来自 bundle 的试用
    @computed get isBundleTrail(){
        if(this.isTrial && this.isBundle) return true;
        return false;
    }
    // bundle 试用过期
    @computed get isBundleTrialExpired(){
        if(this.isTrialExpired && this.isBundle) return true;
        return false;
    }
    // start ---> Marketing strategy <---
    @computed get isDashboardTrial(){
        return this.dashboardTrial;
    }
    @computed get isFirstTrial(){
        if(this.subscribeInfo && this.subscribeInfo.current_timestamp && this.subscribeInfo.phantom_online_trial_start_timestamp ){
            return Math.abs(this.subscribeInfo.current_timestamp - this.subscribeInfo.phantom_online_trial_start_timestamp) <=5
        }else{
            return false
        }
    }

    @computed get isNeedTrailState(){
        if (!this.isActive && !this.isTrial && !this.isTrialExpired && !this.isExpired) {
            return true;
        }
        if (!this.isActive && (this.isTrialExpired || this.isExpired)) {
            return false;
        }
        if(!this.isActive && this.isTrial){
            return false;
        }
        return true;
    }

    @computed get forShowStartTrail(){
        return !this.isActive && !this.isTrial && !this.isTrialExpired && !this.isExpired;
    }

    @computed get forShowUpgrade(){
        return !this.isActive && (this.isTrialExpired || this.isExpired);
    }

    @computed get isFirstFreeUser(){
        if(this.isActive){
            return false
        }else{
            if (!this.isTrial && !this.isTrialExpired && !this.isExpired || this.isNoFirstTrail) {
                return true;
            }
            if (this.isTrialExpired || this.isExpired || this.isTrial) {
                return false;
            }
            return true;
        }
    }

    @computed get userSubStripeId(){
        return this.user_stripe_sub_num;
    }

    @action initialize() {
      this.initializeTask = appStoreCloudApis.initialize();
      if (!store.appStore.isOnPremiseDeployMode) {
          store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, ()=>{
              this.doGetSubscribeInfo();

              // this.doGetUserAllApps(()=>{
              // })
          });
      }

    //   window.addEventListener('message', (event)=>{
    //       let MESSAGE_KEY = 'appstore.msg';
    //       if (event.data[MESSAGE_KEY]) {
    //           let origin = this.getSubscribeType('latest')
    //           this.doGetSubscribeInfo().then(() => {
    //               otelApi.sendJaegerData({
    //                   spanName: 'subscribe_success',
    //                   operationName: 'subscribe_success',
    //                   extraInformation: {
    //                       _group3: 'activities',
    //                       origin,
    //                   },
    //                   moreInfo: {
    //                       productType: this.getSubscribeType('latest')
    //                   }
    //               })
    //           });
    //       }
    //   }, false);
    }

    @action getTrialPermission(feature){
        let permission = null
        if(!this.dashboardPermission || this.dashboardPermission.length === 0){
            return permission;
        }

        this.dashboardPermission.some((value)=>{
            const {name, duration, times} = value;
            let iDuration = parseInt(duration) || 0;
            let iTimes = parseInt(times) || 0;
            let isIn = permissionManager.isSupportFeature(name, feature);
            if(!isIn && (name === feature)){
              permission = {duration:iDuration, times:iTimes, name};
              return true;
            }

            if(!isIn){
                return false;
            }
            //
            permission = {duration:iDuration, times:iTimes, name};
            return true;
        });

        return permission;
    }
    @action getComponentsToHide(){
      if(!this.dashboardPermission || !this.dashboardPermission[0]){
        return;
      }
      let features = [];
      this.dashboardPermission.map((value)=>{
        const {name, duration, times} = value;
        let iDuration = parseInt(duration) || 0;
        let iTimes = parseInt(times) || 0;
        if(iDuration === 0 && iTimes === -2){
          features.push(name);
        }
      });
      return features;
    }
    @action debugDashboardPermission(){
        this.dashboardPermission = [{"duration": "10000", "times": 1, "name": "PDF2Office"}];
        this.dashboardTrial = true;
        this.loadTrialPermissionFromStorage();
        store.appStore.emitEvent(GOT_USER_SUBSCRIPTION);
        store.appStore.emitEvent(USER_UPDATE_SUBSCRIPTION);
    }
    /** data
     * be called after login in and app plan
    */
    @action loadTrialPermissionFromStorage(){
        // from server
        accountService.getUserMetadata(USER_TEMP_TRIAL, (szTrialInfo)=>{
            let trialInfo = JSON.parse(szTrialInfo);
            if(!trialInfo)return;
            this.dashboardTrialInfo = trialInfo;
        })
        // from local
        const {userId} = store.userStore;
        let szValues = localStorage.getItem(USER_TEMP_TRIAL);
        if(!szValues)return;
        let values = JSON.parse(szValues);
        let trialInfo = values[userId];
        if(!trialInfo)return;
        // {nameKey:{timestamp, usedTimes}, ...}
        this.dashboardTrialInfo = trialInfo;
    }
    @action updateTrialPermissionToStorage(){
        let keys = Object.keys(this.dashboardTrialInfo);
        if(keys.length === 0)return;
        // to server
        let szTrialInfo = JSON.stringify(this.dashboardTrialInfo);
        accountService.setUserMetadata(USER_TEMP_TRIAL, szTrialInfo, (/* szTrialInfo */)=>{
            console.log('save szTrialInfo success')
        },(err)=>{
            console.error('save szTrialInfo error', err)
        })

        // to local
        const {userId} = store.userStore;
        let szValues = localStorage.getItem(USER_TEMP_TRIAL);
        let trialInfos = {};
        if(szValues){
            let values = JSON.parse(szValues);
            trialInfos = values;
        }
        trialInfos[userId] = this.dashboardTrialInfo;
        let sz = JSON.stringify(trialInfos);
        localStorage.setItem(USER_TEMP_TRIAL, sz);
    }
    // times = times + 1
    @action updateTrialPermission(feature){
        //
        let permisson = this.getTrialPermission(feature);
        if(!permisson)return;
        const {name} = permisson;
        let info = permissionManager.updateUserTrialInfo(permisson, this.dashboardTrialInfo);
        this.dashboardTrialInfo[name] = info;
        // sync storage
        this.updateTrialPermissionToStorage();
    }
    @action getPermissionByDashboard(feature){
        if(!isMore20201231()){
            return {permisson:null, isAllowed: false};
        }
        let permisson = this.getTrialPermission(feature);
        if(!permisson)return {permisson:null, isAllowed: false};
        let result = permissionManager.calcPermission(permisson, this.dashboardTrialInfo);
        const {permissonDetail, dashboardTrialInfo, isUpdatedTrialInfo} = result;
        if(isUpdatedTrialInfo){
            this.dashboardTrialInfo = dashboardTrialInfo;
        }
        return permissonDetail;
    }
    // end ---> Marketing strategy <---

    @action getDistributorName() {
        let val = getQueryVariable('distributorID');
        if (val) {
            this.distributorID = val;
            if (val === 'ng28a5' || val === 'ng47a6' || val === 'ngec75') {
                return "NexstGo";
            }
        }
        return null;
    }
    @action getSubscribeType(type) {
        let result = ''
        let index = 0
        const apps = this.apps

        if (type === 'latest') {
            index = apps.length - 1
        }

        if (apps && apps.length !== 0 && apps[index].app_code && apps[index].status === 'active') {
            result = apps[index].app_code.substr(11);
        } else if (apps && apps.length !== 0 && apps[index].app_code === '' && apps[index].status === 'trail') {
            result = 'trial';
        } else {
            result = 'free';
        }

        return result
    }

    @action doGoToAppShopping({target, app_code, planType, original = false}){
        const inTeamsApp = !!msForTeamsAppApi.email;
        let distributor = this.getDistributorName();
        let isUS = isPdfOnlineDomain();
        let isEU = isCommonFeatureDomain();
        let isDemo4 = isDemo4Domain();
        //
        if((isUS || isEU || isDemo4) && !(target === 'app-detail' && app_code === 'phantom_ga_online')){
            let winEnv;
            let fn = (targetUrl)=>{
                if (winEnv.closed) {
                    return
                }
                !!targetUrl && (updateProp(winEnv.document.location, 'href', targetUrl));
                let _hTime = setInterval(()=>{
                    if(winEnv.closed) {
                        clearInterval(_hTime);
                        this.doGetSubscribeInfo();
                    }
                },2000);
            }
            if (inTeamsApp) {
                fn = (targetUrl) => {
                    msForTeamsAppApi.msTeamsAuthenticationAuthenticate({
                        url: targetUrl,
                        width: 1280,
                        height: 1024,
                        failureCallback: () => {
                            this.doGetSubscribeInfo();
                        }
                    });
                };
            } else {
                winEnv = windowActionFn(window, 'open', ['about:blank']);
            }
            if (distributor === 'NexstGo' ) {
                return accountService.getAppShoppingTargetUrlByNexstGo({ app_code, planType, target }, fn)
            }
            //
            return accountService.getAppShoppingTargetUrl({ app_code, planType, target, original }, fn)
        }
        // default
        let url = this.getAppStoreTargetUrl({target:target, app_code})
        let ticketUrl = this.getAppStoreTargetUrl({target:'ticket-redirect'});
        this.doGoToAppStore(ticketUrl, url, ()=>{
        })
    }

    @action getAppStoreTargetUrl({target, app_code}){
        //https://appstore-fz02.connectedpdf.com/appstore/app-detail?app_code=phantom_ga_standard
        //https://appstore-fz02.connectedpdf.com/appstore/app-detail?app_code=phantom_ga_business
        //https://appstore-fz02.connectedpdf.com/appstore/my-cards
        //https://appstore-fz02.connectedpdf.com/appstore/my-invoices
        const appStoreUrl = getFoxitStoreDomain()

        if(!appStoreUrl)return '';

        let map = {
            'my-order': appStoreUrl + `/appstore/purchased`,
            'ticket-redirect':appStoreUrl + `/appstore/ticket-redirect`,
            'app-detail': appStoreUrl +'/appstore/app-detail?app_code='+app_code +'&return=no_return&post_message=online&trackingId=phantompdf_online',
            'my-cards': appStoreUrl +'/appstore/my-cards' + '?return=no_return&post_message=online&trackingId=phantompdf_online',
            'my-invoices':appStoreUrl +'/appstore/my-invoices'  + '?return=no_return&post_message=online&trackingId=phantompdf_online',
            'app-list': appStoreUrl + '/appstore/app-list',
            'teachers-day': appStoreUrl + '/appstore/app-detail?app_code=phantom_ga_education&trackingId=productpage_edu_editor&mode=A?from=onlineedu'
        }

        let url = map[target]

        if(!url)return '';

        return url;
    }
    @action doGoToAppStore(ticketUrl, redirectUrl, callback){
        if(!ticketUrl || !redirectUrl)return;
        const inTeamsApp = !!msForTeamsAppApi.email;
        let winEnv;
        let fn;
        if (inTeamsApp) {
            fn = (targetUrl) => {
                msForTeamsAppApi.msTeamsAuthenticationAuthenticate({
                    url: targetUrl,
                    width: 1280,
                    height: 1024,
                    failureCallback: () => {
                        callback && callback()
                        store.accountStore.doGetSubscribeInfo();
                    }
                });
            };
        } else {
            winEnv = windowActionFn(window, 'open', ['about:blank']);
            fn = (targetUrl) => {
                if(winEnv.closed) {
                    return
                }
                winEnv.document.location.href = targetUrl;

                let _hTime = setInterval(()=>{
                    if(winEnv.closed) {
                        clearInterval(_hTime)
                        callback && callback()
                        store.accountStore.doGetSubscribeInfo()
                    }
                },2000);
            }
        }
        store.userStore.doGetTicket(ticketUrl, (ticket) => {
            let lang = store.appStore.lng ? store.appStore.lng.full: '';
            if(lang){
                if (redirectUrl.indexOf('?') === -1) {
                    redirectUrl = redirectUrl + '?lang=' + lang;
                } else {
                    redirectUrl = redirectUrl + '&lang=' + lang;
                }
            }

            if (this.distributorID) {
                if (redirectUrl.indexOf('?') === -1) {
                    redirectUrl = redirectUrl + '?distributorID=' + this.distributorID;
                } else {
                    redirectUrl = redirectUrl + '&distributorID=' + this.distributorID;
                }
            }
            let targetUrl = `${ticketUrl}?redirectUrl=${encodeURIComponent(redirectUrl)}&ticket=${ticket}&lang=${lang}`;
            if(!ticket){
                targetUrl = redirectUrl;
            }
            fn(targetUrl);
        });
    }

    @action doActivate(license, callback, error){
        accountService.doActivate(license, callback, error)
    }
    @action doGetProductPlans(callback){
        let codes = this._app_codes;
        accountService.getPlans(codes).then((plansMap)=>{
            this.plans = plansMap;
            callback && callback()
            //let details = accountService.parsePlans(plansMap)
        }).catch(()=>{
            callback && callback()
        })
    }

    @action isActiveStateForCache(data){
      let apps = accountService.getSubscribedApps(data);
      this.trial_from = data.trial_from;
      let subscriptionState = accountService.getSubStatus(data, apps);
      if (!subscriptionState) return false;
      if (subscriptionState.status !== 'active')
        return false;
      return true;
    }

    @action updateSubscribeState(subscribeInfo, disableEvent, disablePayDlgEvent=false) {
        let data = subscribeInfo? subscribeInfo: this.subscribeInfo;
        let apps = accountService.getSubscribedApps(data);
        this.trial_from = data.trial_from;
        let subscriptionState = accountService.getSubStatus(data, apps);
        this.subscribeInfo = data;
        this.apps = apps;
        this.subscriptionState = subscriptionState;
        this.user_stripe_sub_num = accountService.getSubStripeId(data,apps);
        !disablePayDlgEvent && store.appStore.emitEvent(GOT_USER_SUBSCRIPTION);


        !disableEvent && store.appStore.emitEvent(USER_UPDATE_SUBSCRIPTION);

        if (this.isBundle && ['active'].includes(this.subscriptionState.status)) {
            store.appStore.emitEvent('has-close-shopping-car',false);
        }
    }
    @action setUserStripeSubNum(id){
        this.user_stripe_sub_num = id;
    }

    @action getSubscribeStateNow(){
        const fn = async ()=>{
            try {
                const data = await accountService.doGetSubscribeInfo()
                this.subscribeInfoCache = data;
                this.updateSubscribeState(data, true,true)
            } catch (error) {
                console.error(error);
            }
        }
        fn();
    }

    @action getSubscribeStateData(){
        return accountService.doGetSubscribeInfo();
    }

    @action loadSubscribeInfo(preload){
      if(!this.requestTask){
        this.requestTask = accountService.doGetSubscribeInfo(preload).then((data) => {
          this.subscribeInfoCache = data;
          return data;
        })
      }
      return this.requestTask;
    }
    @action subscribeSuccessAutoRefresh() {
        let targetFun
        let retryNum = 0
        const { isEnterpriseUser } = store.userStore

        if (subscribeInfoIntervalFlag) {
            clearInterval(subscribeInfoIntervalFlag)
        }

        if (isEnterpriseUser) {
            targetFun = async () => {
                try {
                    await userService.checkRole()

                    if(await store.userStore.hasSubscribePermission()) {
                        windowActionFn(window.location, 'reload')
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        } else {
            targetFun = async () => {
                try {
                    const data = await accountService.doGetSubscribeInfo()

                    this.subscribeInfoCache = data;
                    this.updateSubscribeState(data, true)

                    if(await store.userStore.hasSubscribePermission()) {
                        windowActionFn(window.location, 'reload')
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }

        subscribeInfoIntervalFlag = setInterval(() => {
            retryNum++

            if (retryNum >= 10) {
                clearInterval(subscribeInfoIntervalFlag)
                return
            }

            targetFun()
        }, 1000 * 60);
    }

    @action preloadAccountDetails(){
        return this.initializeTask.then(() => Promise.all([this.loadSubscribeInfo(true)]));
    }

    @action sendSubscribeGA(){
      if (this.isActive) {
        let plans = [];
        this.apps.forEach((app) => {
          const { app_code, plan_type } = app;
          plans.push('plan_' + app_code + '_' + plan_type);
        });
        store.userStore.doSendGAEventByUserEvent(SUBSCRIBED_PLAN, plans.join('_&_'), null);
      } else {
        store.userStore.doSendGAEventByUserEvent(SUBSCRIBED_NO_PLAN, null, null);
      }
    }

    @action async doGetSubscribeInfo() {
        // if is enterprise user, do not request personal subscription
        if (store.userStore.isEnterpriseUser) {
            store.appStore.emitEvent(GOT_USER_SUBSCRIPTION);
            return;
        }
        const data = await this.loadSubscribeInfo();
        this.updateSubscribeState(data, true);
        this.subscribeInfoCache = null;
        this.requestTask = null;

        const isEdu = store.userStore.isEdu;
        if (!this.isActive && !this.isTrial && isEdu) {
            await this.docheckDashboardPermission();
        }
        store.appStore.emitEvent(GOT_USER_SUBSCRIPTION);
        store.appStore.emitEvent(USER_UPDATE_SUBSCRIPTION);
        this.sendSubscribeGA();
    }
    @action doMockSubscribe(status){
        accountService.doMockSubscribe(status, ({data})=>{
            this.updateSubscribeState(data);
        })
    }
    @action docheckDashboardPermission(){
        /**{ "ret": 0, "data": { "policy": { "functions": [ { "duration": "10000", "times": "10", "name": "PDF2Office" } ] } } } */
        return userService.checkDashboardPermission((result)=>{
            this.dashboardTrial = true;
            if(result.data && result.data.policy && result.data.policy.functions){
                this.dashboardPermission = result.data.policy.functions
                this.loadTrialPermissionFromStorage();
            }
        }, (err)=>{
            console.warn("===>>> ~ AccountStore ~ @action docheckDashboardPermission ~ err", err);
        })
    }
    /**
     *
     *
     * @returns{SubscribeInfo}
     */
    @action getSubscribeInfo(){
        return this.subscribeInfo;
    };
    @action setSubscribeInfo(data){
        this.subscribeInfo = data;
    }
    @action setTrialFrom(from){
        this.trial_from = from;
    }
    @action setSubscriptionState(status){
        this.subscriptionState = { status };
    }
/*
    @action getAppCode(){
        let subInfo =  this.getSubscribeInfo();
        if(!subInfo || !subInfo.isSubscribed){
            return null;
        }
        for (let index = 0; index < subInfo.subscribedApps.length; index++) {
            const subApp = subInfo.subscribedApps[index];
            for (let j = 0; j < subApp.length; j++) {
                const sub = subInfo.subscribedApps[j];
                return sub.app_code;
            }
        }
        return null;
    };*/
    /**
     * @returns {Promise<String>}
     */
    @action doGetStripeKey(){
        //let key = await  appStoreApis.doGetStripeKey();
        return appStoreCloudApis.doGetStripeKey();
    }
    @action clean(){
        this.subscriptionState = null;
    }

}
export default AccountStore;